/**
 * 606 Meta5 AI Trading - Terminal Log Component
 */
import React, { useEffect, useRef } from 'react';

const levelColors = {
  INFO: 'text-cyan-400',
  DECISION: 'text-[#d4af37]',
  TRADE: 'text-emerald-400',
  WARN: 'text-amber-400',
  ERROR: 'text-red-400',
};

const TerminalLog = ({ logs = [], maxHeight = 300 }) => {
  const scrollRef = useRef(null);
  
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [logs]);
  
  const formatTime = (timestamp) => {
    try {
      const date = new Date(timestamp);
      return date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit', 
        second: '2-digit',
        hour12: false 
      });
    } catch {
      return '--:--:--';
    }
  };
  
  return (
    <div 
      ref={scrollRef}
      className="bg-[#0a0a0a] rounded-lg border border-[#2a2a4e] overflow-auto font-mono text-xs"
      style={{ maxHeight }}
    >
      <div className="p-3 space-y-1">
        {logs.length === 0 ? (
          <div className="text-[#606060] text-center py-4">No logs available</div>
        ) : (
          logs.map((log, idx) => (
            <div key={log.id || idx} className="flex gap-2 hover:bg-white/5 px-1 py-0.5 rounded">
              <span className="text-[#606060] shrink-0">{formatTime(log.timestamp)}</span>
              <span className={`shrink-0 w-16 ${levelColors[log.level] || 'text-white'}`}>
                [{log.level}]
              </span>
              {log.symbol && (
                <span className="text-purple-400 shrink-0">{log.symbol}</span>
              )}
              <span className="text-white/80">{log.message}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TerminalLog;
